export const SET_BANK_LIST = 'SET_BANK_LIST'
export const GET_BANK_LIST = 'GET_BANK_LIST'
export const SET_BANK_SELECTED = 'SET_BANK_SELECTED'
export const GET_BANK_SELECTED = 'GET_BANK_SELECTED'
export const FETCH_BANK_LIST = 'FETCH_BANK_LIST'
export const UPDATE_BANK_LIST = 'UPDATE_BANK_LIST'
export const EFT_MODULE = 'eft'
